module.exports = __webpack_public_path__ + "img/sudbury_b2.486d3935.jpg";